<div class="range-slider overlay" 
     [style.--track-height.px]="height" 
     [style.--primary-color]="background" 
     [style.color]="color" 
     [style.--min]="min" 
     [style.--max]="max" 
     [style.--value-a]="minVal" 
     [style.--value-b]="maxVal">
  
  <input type="range" 
         [min]="min" 
         [max]="max" 
         [(ngModel)]="minVal" 
         (input)="changeMin()" 
         (change)="changeMin()"/>

  <input type="range" 
         [min]="min" 
         [max]="max" 
         [(ngModel)]="maxVal" 
         (input)="changeMax()" 
         (change)="changeMax()"/>

  <div class='range-slider__progress'></div>
</div>

<div *ngIf="title" class="range-title">
  {{ minVal }} {{ symbol }} - {{ maxVal }} {{ symbol }}
</div>